import { Component } from '@angular/core';

@Component({
	selector: 'page-404',
	template: `
    <div class='center'>
      <h1>Sorry, this page doesn't exist !</h1>
      <a routerLink="/" class="waves-effect waves-teal btn-flat">
        back
      </a>
    </div>
  `
})
export class PageNotFoundComponent { }
